import { ColumnDef } from "@tanstack/react-table";
import { EditIcon, TrashAltIcon } from "assets/icons";
import { Media } from "components";
import { useLanguage } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ItemsTable, TableItemActionsControl } from "ui";

import { ContentVideoListItem } from "../../content.types";
import { VideosTableProps } from "./VideosTable.types";

import styles from "./VideosTable.module.scss";

const VideosTable = ({
  videos,
  sorting,
  setSorting,
  onDeleteVideo,
  onEditVideo,
  isLoading,
  onWatchVideo
}: VideosTableProps) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  const [openedItemOptionsIndex, setOpenedItemOptionsIndex] = useState<
    number | null
  >(null);

  const columns: Array<
    ColumnDef<ContentVideoListItem, ContentVideoListItem[]>
  > = useMemo(
    () => [
      {
        header: t("Thumbnail"),
        enableSorting: false,
        size: 10,
        minSize: 10,
        cell: ({ row }) => {
          const image = videos[row.index].thumbnail;
          return (
            <div className={styles.videosTable_imageCell_thumb}>
              {image && (
                <Media
                  className={styles.videosTable_imageCell}
                  mediaFile={image}
                />
              )}
            </div>
          );
        }
      },
      {
        id: "title",
        accessorKey: "title",
        header: t("Title"),
        size: 30,
        minSize: 30,
        cell: ({ row }) => videos[row.index].title
      },
      {
        id: "description",
        header: t("Description"),
        accessorKey: "description",
        size: 46,
        minSize: 46,
        cell: ({ row }) => videos[row.index].description
      },

      {
        id: "targetResellerLevel",
        header: t("User type"),
        accessorKey: "targetResellerLevel",
        size: 10,
        minSize: 10,
        cell: ({ row }) => videos[row.index].targetResellerLevel ?? t("All")
      },

      {
        accessorKey: "dotsColumn",
        header: () => null,
        size: 3,
        minSize: 3,
        cell: ({ row }) => (
          <TableItemActionsControl
            actionsList={[
              {
                label: "Edit",
                Icon: <EditIcon fill={"#090914"} width={18} height={18} />,
                onClick: () => onEditVideo(videos[row.index])
              },
              {
                label: "Delete",
                Icon: <TrashAltIcon fill={"#ff0033"} width={18} height={18} />,
                labelColor: "#ff0033",
                onClick: () => onDeleteVideo(videos[row.index].id)
              }
            ]}
            rowIndex={row.index}
            setOpenedItemOptionsIndex={setOpenedItemOptionsIndex}
            openedItemOptionsIndex={openedItemOptionsIndex}
          />
        ),
        enableSorting: false
      }
    ],
    [videos, openedItemOptionsIndex, currentLanguage]
  );

  return (
    <ItemsTable
      columns={columns}
      data={videos}
      sorting={sorting}
      skeletonHeight={65}
      setSorting={setSorting}
      isLoading={isLoading}
      onRowClick={(video) => onWatchVideo(video)}
    />
  );
};

export default VideosTable;
